import { ICON__copy_regular } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { useToast } from '@/hooks/use-toast';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';

interface PROPS {
  field: FIELD__list_token;
}

export function G_BUTTON__prompt_copy_to_clipboard({ field }: PROPS) {
  const { toast } = useToast();
  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let tokens = get_tokens_to_copy();
    if (tokens.is_empty()) return;

    let prompt = tokens.map(token => token.toString()).join('\n');

    await navigator.clipboard.writeText(prompt);

    toast({ title: 'Copied to clipboard' });
  }

  /*
   *
   */

  function get_tokens_to_copy() {
    let out = field.get_enabled_and_non_zero_weight_items();

    out = out.filter(item => item.type == ENUM__token_type.WORD);

    return out;
  }

  function is_disabled() {
    return get_tokens_to_copy().is_empty();
  }

  /*
   *
   */

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-bar"
      size={'rect-10-5'}
      Icon={ICON__copy_regular}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      iconClassNameBase={`!size-3 !text-component-item-foreground'}`}
      iconClassNameHovered={`text-bar-foreground'}`}
      disabled={is_disabled()}
      {...{ onClick }}
    />
  );
}
